(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lucka-destacado"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lucka-destacado')) {
    class LuckaDestacado extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', this.alCambiar);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.alCambiar);
      }

      alCambiar = (evento) => {
        const radio = evento.target;
        if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
        const datos = radio.dataset;

        const img = this.querySelector('[data-lucka-destacado-img]');
        if (img && datos.img) {
          img.srcset = datos.srcset || '';
          img.src = datos.img;
          img.alt = datos.alt || '';
        }

        const color = this.querySelector('[data-lucka-destacado-color]');
        if (color) color.textContent = datos.color || '';

        const precio = this.querySelector('[data-lucka-destacado-precio]');
        if (precio && datos.precio) precio.textContent = datos.precio;

        const estado = this.querySelector('[data-lucka-destacado-estado]');
        if (estado) estado.hidden = datos.disponible === 'true';

        if (datos.url) {
          this.querySelectorAll('[data-lucka-destacado-enlace]').forEach((enlace) => {
            enlace.setAttribute('href', datos.url);
          });
        }
      };
    }

    customElements.define('lucka-destacado', LuckaDestacado);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
